// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__17-6t","footer":"ModalFilter_footer__1vxzs"};